/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import axios from "axios";
import { ServicePath,UtilFront } from "@/core";

export default class ProductsRequest {
    static listAll() {
        return axios.post(ServicePath.PRODUCT_LIST_ALL);
    }
    static add(object) {
        return axios.post(ServicePath.PRODUCT_ADD, object);
    }
    static update(object) {
        return axios.post(ServicePath.PRODUCT_UPDATE,object);
    }
    static listAllUnitMeasurement() {
        return axios.post(ServicePath.GET_ALL_PRODUCT_UNIT_MEASUREMENT);
    }
    static listAllBrand(){
        return axios.post(ServicePath.BRAND_ALL)
    }
    static listAllTypeProducts(){
        return axios.post(ServicePath.TYPE_PRODUCT_ALL)
    }
    static brandbyproduct(object){
        return axios.post(ServicePath.PRODUCT_BRAND,object)
    }
    static brandbyid(object){
        return axios.post(ServicePath.BRAND_BY_ID,object)
    }
}